<template>
  <section>
    <layout-pay-box-section :with-header="false">
      <template #main>
        <b-tabs
          id="purchaseInfoTab"
          v-model="actualTab"
          fill
          @activate-tab="onTabChange"
        >
          <b-tab
            id="purchase-tab-product"
            class="content-tab"
            :style="{ height: `${getHeightTabContent}px` }"
            :disabled="isConsignedSaleFinish"
          >
            <template #title>
              <p class="m-0">
                PRODUTO
                <e-shortcut :shortcuts="['F6']" />
              </p>
            </template>
            <product-tab ref="productTab" />
          </b-tab>

          <b-tab
            id="purchase-tab-client"
            class="content-tab"
            :style="{ height: `${getHeightTabContent}px` }"
          >
            <template #title>
              <p class="m-0">
                CLIENTE
                <e-shortcut :shortcuts="['F7']" />
              </p>
            </template>
            <client-tab
              ref="clientTab"
              @use-reward-credits="onUseRewardCredits"
            />
          </b-tab>

          <b-tab
            id="purchase-tab-payment"
            class="content-tab"
            :style="{ height: `${getHeightTabContent}px` }"
          >
            <template #title>
              <p class="m-0 text-upper">
                PAGAMENTO
                <e-shortcut :shortcuts="['F10']" />
              </p>
            </template>
            <payment-tab ref="paymentTab" />
          </b-tab>
        </b-tabs>
      </template>

      <template #footer>
        <b-row class="h-100 d-flex align-items-center">
          <b-col>
            <e-button
              id="paybox_purchase-btn_cancel"
              :busy="isFinishingSale"
              variant="danger"
              :text="isExistingSale ? $t('SAIR') : $t('CANCELAR')"
              :icon="'x-circle'"
              size="sm"
              tabindex="-1"
              block
              :text-shortcuts="['F5']"
              @click="onCancel"
            />
          </b-col>
          <b-col v-if="false">
            <e-button
              id="paybox_purchase-btn_delivery"
              :busy="isFinishingSale"
              variant="dark"
              :text="$t('ENTREGA')"
              :icon="'truck'"
              size="sm"
              block
              :text-shortcuts="[]"
              @click="onShowDeliveryAddress"
            />
          </b-col>
          <b-col v-if="isConsignedSaleFinish">
            <e-button
              id="paybox_purchase-btn_items_return"
              :busy="isFinishingSale"
              variant="dark"
              :text="$t('DEVOLUÇÕES')"
              :icon="'arrow-clockwise'"
              size="sm"
              block
              @click="onShowReturnItems"
            />
          </b-col>
          <b-col>
            <e-button
              id="paybox_purchase-btn_finish"
              :busy="isFinishingSale"
              variant="primary"
              :text="tabEnum.payment === actualTab ? getFinishLabel : $t('PAGAMENTO')"
              :icon="'check-circle'"
              size="sm"
              block
              :text-shortcuts="['F10']"
              @click="onFinish"
            />
          </b-col>
        </b-row>
      </template>
    </layout-pay-box-section>

    <!-- <modal-finished
      v-show="saleFinished"
      ref="modalFinished"
      :data-finished="dataFinished"
      @click-next="onCleanSale"
    /> -->

    <modal-return-items
      ref="modalReturnItems"
      show-products
      :return-form="returnForm"
      :sale-data="getConsignedReturnData"
      @confirm="onConfimReturnForm"
    />

    <modal-delivery-address
      v-if="false"
      ref="modalDeliveryAddress"
      :delivery-form="deliveryForm"
      :address-list="clientForm.addressList"
      @click-confirm="onConfirmDeliveryAddress"
    />

    <modal-cold-option ref="modalColdOption" />
  </section>
</template>

<script>
import { BTabs, BTab, BRow, BCol } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import {
  app,
  keyboardCode,
  loadingOverlay,
  saleDomain,
  personTypes,
  invoiceDomains,
} from '@/mixins'
import EButton from '@/views/components/EButton.vue'
import EShortcut from '@/views/components/EShortcut.vue'
import delegablePermissions from '@/utils/delegable-permissions'
import EventBus from '@/utils/EventBus'
import { trackEvent } from '@/frontend-monitoring'
import LayoutPayBoxSection from './LayoutPayBoxSection.vue'
import ProductTab from './tabs/ProductTab.vue'
import ClientTab from './tabs/ClientTab.vue'
import PaymentTab from './tabs/PaymentTab.vue'
import ModalDeliveryAddress from './ModalDeliveryAddress.vue'
import ModalReturnItems from './modals/ModalReturnItems.vue'
import ModalColdOption from './modals/ModalColdOption.vue'

export default {
  components: {
    LayoutPayBoxSection,
    BTabs,
    BTab,
    BRow,
    BCol,
    EButton,
    ProductTab,
    ClientTab,
    PaymentTab,
    EShortcut,
    ModalDeliveryAddress,
    ModalReturnItems,
    ModalColdOption,
  },

  mixins: [app, keyboardCode, loadingOverlay, saleDomain, personTypes],

  props: {
    getHeight: {
      type: Number,
      required: true,
    },
    tabHeight: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      saleFinished: false,
      dataFinished: {
        date: new Date(),
      },
      actualTab: 0,
      delegateUserData: null,
      tabEnum: {
        product: 0,
        client: 1,
        payment: 2,
      },
      isFinishingSale: false,
    }
  },

  computed: {
    ...mapState('app', ['modalAuthRef']),
    ...mapState('pages/pdv/payBox', [
      'items',
      'returnForm',
      'clientForm',
      'paymentForm',
      'paymentStarted',
      'deliveryForm',
      'consignedMaxReturnValue',
      'invoiceReturn',
      'orderChanged',
      'coldOption',
    ]),
    ...mapGetters('pages/pdv/payBox', [
      'getConsignedReturnData',
      'getItems',
      'getPriceTable',
      'getCustomerDocument',
      'getCustomerName',
      'getTotalSale',
      'isOrder',
      'isBarConsumption',
      'hasNewPalmBeerOperation',
      'isConsignedSaleFinish',
      'isConsignedSalePayment',
      'hasActiveTefCardPayment',
      'hasReturnSaleItems',
      'isNfeRequired',
      'clientHasValidAddressToInvoice',
      'hasColdOptionProducts',
      'hasCashPayment',
      'salePriceTable',
    ]),
    ...mapGetters('pages/pdv/payBoxTefRequestData', {
      isTefCustomerDocumentWaiting: 'isTefCustomerDocumentWaiting',
    }),
    ...mapGetters('pages/pdv/payBoxConfiguration', ['isKioskStore']),
    ...mapGetters('pages/pdv/payBoxInvoice', ['getInvoiceLimitExceededValue']),

    getHeightTabContent() {
      // subtract title tabs
      return this.getHeight - this.tabHeight
    },

    getFinishLabel() {
      let label = this.$t('FINALIZAR')
      if (this.isConsignedSalePayment) label = this.$t('REGISTRAR PAGAMENTO')
      return label
    },

    isExistingSale() {
      return this.isOrder || this.isBarConsumption
    },
  },

  created() {
    this.addKeyEvent(this.purchaseInfoShortcuts)
    EventBus.$on('client-tab-select', () => {
      this.actualTab = this.tabEnum.client
    })
    EventBus.$on('payment-tab-select', () => {
      this.actualTab = this.tabEnum.payment
    })
  },

  mounted() {
    if (this.isConsignedSaleFinish || this.isConsignedSalePayment) {
      setTimeout(() => {
        this.actualTab = this.tabEnum.payment
        this.addKeyEvent(this.$refs.paymentTab.paymentShortcut)
      }, 300)
      return
    }

    this.$refs.productTab.startProductTabEvents()
  },

  beforeDestroy() {
    this.removeKeyEvent(this.purchaseInfoShortcuts)
    if (this.$refs.paymentTab?.paymentShortcut) {
      this.removeKeyEvent(this.$refs.paymentTab.paymentShortcut)
    }

    this.$refs.productTab.endProductTabEvents()
  },

  methods: {
    ...mapActions('pages/pdv', ['updateTotalCashInPdv']),
    ...mapActions('pages/pdv/payBox', {
      stCleanPayBox: 'cleanState',
      stValidateFinishSale: 'validateFinishSale',
      stFinishSale: 'finishSale',
      stStartPayment: 'setStartPayment',
      stSetDeliveryData: 'setDeliveryData',
      stSetReturnForm: 'setReturnForm',
      stAddTempDelegation: 'AddTempDelegation',
      stCancelIncompleteInvoice: 'cancelIncompleteInvoice',
      stClearPayBoxRewardData: 'clearPayBoxRewardData',
      stPayBoxSaleOrderRelease: 'payBoxSaleOrderRelease',
    }),
    ...mapActions('pages/pdv/payBoxInvoice', {
      stCleanPayBoxInvoiceMetadata: 'cleanPayBoxInvoiceMetadata',
    }),

    clientIsAnonymous() {
      return this.clientForm.personType === this.personTypeEnum.CONSUMER
    },

    onUseRewardCredits(rewardBalance) {
      // Emitir evento para o componente principal do PDV aplicar o desconto
      this.$emit('use-reward-credits', rewardBalance)
    },
    onTabChange(newTab, prevTab, event) {
      if (prevTab === this.tabEnum.client && !this.$refs.clientTab.validate()) {
        this.showWarning({ message: this.$t('Dados incorretos no formulário de clientes') })
        event.preventDefault()
        return
      }

      if (newTab === this.tabEnum.client && !this.$refs.clientTab.validate())
        this.showWarning({ message: this.$t('Dados incorretos no formulário de clientes') })

      this.removeKeyEvent(this.$refs.paymentTab.paymentShortcut)
      this.$refs.productTab.endProductTabEvents()
      this.$refs.clientTab.endCustomerTabShortcut()

      if (newTab === this.tabEnum.product) {
        this.$refs.productTab.startProductTabEvents()
      } else if (newTab === this.tabEnum.client) {
        this.$refs.clientTab.onFocusDocument()
        this.$refs.clientTab.startCustomerTabShortcut()
      } else if (newTab === this.tabEnum.payment) {
        this.stStartPayment()
        this.addKeyEvent(this.$refs.paymentTab.paymentShortcut)
      }
    },

    saleIsE3Classification() {
      const { E3 } = this.echopeClassificationEnum

      return this.salePriceTable?.echopeClassification === E3
    },

    async onShowReturnItems() {
      this.$refs.modalReturnItems.showModalReturn()
    },
    async onConfimReturnForm(returnForm) {
      try {
        if (returnForm.value > this.consignedMaxReturnValue) {
          const confirmOverflowSaleReturn = await this.confirm({
            text: this.$t('Valor a ser retornado ultrapassou o total permitido.'),
            allowOutsideClick: false,
            allowEscapeKey: true,
            focusCancel: true,
          })
          if (!confirmOverflowSaleReturn) return

          if (!this.$can('SaleReturnCanOverflowMaxValue', 'PayBoxSale')) {
            const delegateUserData = await this.modalAuthRef.auth(
              delegablePermissions.PDV_SALE_RETURN_OVERFLOW_MAX_VALUE
            )
            this.stAddTempDelegation(delegateUserData)
          }
        }

        await this.stSetReturnForm({ returnForm })
        this.$refs.modalReturnItems.hideModal()
      } catch (error) {
        this.showError({ error })
      }
    },

    async onShowDeliveryAddress() {
      this.$refs.modalDeliveryAddress.showModal()
    },
    async onConfirmDeliveryAddress(deliveryForm) {
      this.stSetDeliveryData({ isDelivery: true, deliveryForm })
    },

    async onCancel({ forceExit }) {
      try {
        // TODO: Devemos validar se o usuário realizou as devoluções ? Não adicionei pois não sei ainda oq fazer no fluxo onde não houve devoluções

        if (!this.isOrder && this.hasActiveTefCardPayment) {
          this.showError({
            title: this.$t('Pagamentos TEF'),
            message: this.$t('PAY_BOX_SALE.CANCEL.CONFIRMATION_TEF_PAYMENT_CARD_ACTIVE'),
          })
          this.actualTab = this.tabEnum.payment
          return
        }

        if (!forceExit) {
          let actionMsg = this.$t('Deseja realmente cancelar esta venda?')
          if (this.isOrder)
            actionMsg = this.$t('Deseja sair da venda? As alterações feitas serão perdidas.')
          if (this.isBarConsumption)
            actionMsg = this.$t(
              'Deseja sair do fechamento da comanda? As alterações feitas serão perdidas.'
            )

          const confirm = await this.confirm({
            text: actionMsg,
            focusCancel: true,
          })
          if (!confirm) return

          switch (true) {
            case this.isOrder && !this.orderChanged:
              break
            default:
              this.delegateUserData = await this.modalAuthRef.auth(delegablePermissions.PDV_CANCEL)
          }
        }

        if (this.invoiceReturn && this.invoiceReturn?.model === 'NFE') {
          let delegablePermission = delegablePermissions.ERP_INVOICE_MANAGE

          if (this.invoiceReturn.status === invoiceDomains.data().statusInvoiceEnum.REJECTED) {
            delegablePermission = delegablePermissions.ERP_INVOICE_INVALIDATE
          }

          const delegateUserData = await this.modalAuthRef.auth(delegablePermission)
          this.stAddTempDelegation(delegateUserData)
        }

        this.showLoadingOverlay(this.isExistingSale ? 'Saindo da venda' : 'Cancelando venda')

        await this.stCancelIncompleteInvoice()

        if(this.isOrder) {
          await this.stPayBoxSaleOrderRelease({ saleId: null })
        }

        const isReturnToPendingSale = this.isOrder
        const isReturnToBarTabs = this.isBarConsumption
        await this.onCleanSale()

        if (isReturnToPendingSale) this.$router.push({ name: 'pdv-pay-box-delivery-sales' })
        else if (isReturnToBarTabs) this.$router.push({ name: 'pdv-pay-box-bar-tab-management' })
        else this.showSuccess({ message: this.$t('Venda cancelada') })
      } catch (error) {
        console.error(error)
        const status = error?.response?.status
        if (error.message && status !== 403) {
          this.showWarning({ message: error.message })
        } else {
          this.showError({ error })
        }
      } finally {
        this.hideLoadingOverlay()
      }
    },

    async onFinish() {
      if (this.actualTab !== this.tabEnum.payment) {
        this.actualTab = this.tabEnum.payment
        return
      }
      const validationResult = { errorMessage: '', isInvoiceExceededValueLimits: false }

      if (!this.$refs.clientTab.validate()) {
        if (this.hasNewPalmBeerOperation) {
          validationResult.errorMessage = this.$t(
            'Cliente é obrigatório quando há produto do tipo crédito.'
          )
        } else {
          this.actualTab = this.tabEnum.client
          return
        }
      } else if (this.isConsignedSaleFinish) {
        // `returnedItems` sempre lista TODOS os itens de venda como candidatos
        // a devolução (quantity = 0 por padrão), então checar `length > 0`
        // acusaria devolução mesmo quando nada foi selecionado. A forma de
        // pagamento só é obrigatória quando há item efetivamente devolvido
        // (quantity > 0), sinalizado por `hasReturnSaleItems`.
        if (this.hasReturnSaleItems && this.returnForm.paymentMethod == null) {
          validationResult.errorMessage = this.$t(
            'A forma de pagamento da devolução deve ser informada.'
          )
        }
      } else if (this.isTefCustomerDocumentWaiting) {
        validationResult.errorMessage = this.$t(
          'Por favor, aguarde o cliente informar o documento no PinPad.'
        )
      }

      if (!validationResult.errorMessage) {
        validationResult.errorMessage = this.validateCustomer()
      }

      if (!validationResult.errorMessage) {
        const finishSaleValidationResult = await this.stValidateFinishSale()
        validationResult.errorMessage = this.$t(finishSaleValidationResult.message)
        validationResult.isInvoiceExceededValueLimits =
          finishSaleValidationResult.isInvoiceExceededValueLimits

        if (!validationResult.errorMessage && validationResult.isInvoiceExceededValueLimits) {
          if (this.saleIsE3Classification()) {
            validationResult.errorMessage = this.$t(
              `O limite de valor para vendas sem identificação do cliente é de R$ ${this.$options.filters.currency(
                this.getInvoiceLimitExceededValue
              )}. Vendas com Classificação echope E3 (definida pela tabela de preço) são emitidas sem identificação do cliente.`
            )
          }
        }
      }

      if (validationResult.errorMessage) {
        this.showWarning({ message: validationResult.errorMessage })
        return
      }

      let messages = {
        confirm: { title: this.$t('Finalizar a venda?') },
        overlay: this.$t('Finalizando venda'),
        successToast: { title: this.$t('Venda finalizada') },
      }

      if (this.isConsignedSalePayment) {
        messages = {
          confirm: { title: this.$t('Registrar o pagamento?') },
          overlay: this.$t('Registrando pagamento'),
          successToast: { title: this.$t('Pagamento registrado') },
        }
      }

      const confirm = await this.confirm(messages.confirm)

      if (confirm) {
        this.saleFinished = true

        // lido antes de finalizar porque onCleanSale() limpa os pagamentos da venda
        const saleHasCashPayment = this.hasCashPayment

        try {
          this.isFinishingSale = true

          if (!this.isConsignedSalePayment && this.isNfeRequired) {
            let message = ''
            if (validationResult.isInvoiceExceededValueLimits) {
              message =
                'O valor da venda ultrapassa o limite permitido para emissão do cupom fiscal.'
            } else {
              message = 'Informado na venda um cliente com CNPJ.'
            }

            await this.showInformation({
              text: this.$t('PAY_BOX_SALE.INVOICE.CREATE_NFE_INFO', { message }),
            })

            const delegateUserData = await this.modalAuthRef.auth(
              delegablePermissions.ERP_INVOICE_GENERATE
            )
            this.stAddTempDelegation(delegateUserData)
          }

          if (this.getPriceTable?.id !== 1 && this.isOrder) {
            const delegateUserData = await this.modalAuthRef.auth(
              delegablePermissions.PDV_FINISH_ORDER_NOT_STORE_PRICE_TABLE
            )
            this.stAddTempDelegation(delegateUserData)
          }

          const coldOption =
            this.coldOption ??
            (this.hasColdOptionProducts && !this.isKioskStore
              ? await this.$refs.modalColdOption.showModal()
              : null) ??
            this.coldOptionEnum.NATURAL

          this.showLoadingOverlay(messages.overlay)
          const resultFinishSale = await this.stFinishSale(coldOption)
          console.debug('[stFinishSale] ...')
          await this.onCleanSale()
          console.debug('[onCleanSale] ...')
          this.showSuccess({ ...messages.successToast, message: resultFinishSale.displayMessage })
        } catch (error) {
          this.showError({ error })
          const data = error.response?.data
          if (data?.Request && Array.isArray(data?.Request)) {
            this.showLoadingOverlay(this.$t('PAY_BOX_SALE.CLOSING_ALREADY_FINISHED_OVERLAY'))
            if (
              data.Request.includes('SALE_ORDER.FINISH_ERROR.SALE_ALREADY_COMPLETED_OR_CANCELED')
            ) {
              console.log(
                'OnFinish(), Exception: SALE_ORDER.FINISH_ERROR.SALE_ALREADY_COMPLETED_OR_CANCELED \n Limpando venda atual: onCleanSale()'
              )
              await this.onCleanSale()
            }

            if (
              data.Request?.toString()?.includes(
                'PAY_BOX_SALE.DUPLICATE_UUID_WITH_DIFFERENT_CRITERIA'
              )
            ) {
              trackEvent('PayBoxSaleDuplicateUUID', {
                errorMessage: data.Request?.toString(),
              })
            }
          }
        } finally {
          this.isFinishingSale = false
          this.hideLoadingOverlay()
        }

        // sem dinheiro na venda o total em caixa nao muda, entao nao busca o caixa de novo
        if (saleHasCashPayment) {
          try {
            await this.updateTotalCashInPdv()
          } catch (error) {
            this.showError({ error })
          }
        }
      }
    },

    validateCustomer() {
      const needCustomer =
        this.getItems.some(i => i.skuProduct.customerRequired === true) ||
        this.getItems.some(
          i =>
            i.kitItems?.length > 0 && i.kitItems.some(a => a && a.skuProduct.customerRequired)
        )

      if (needCustomer) {
        if (this.getCustomerDocument === '') {
          return this.$t('PAY_BOX_SALE.CUSTOMER.CUSTOMER_IS_REQUIRED_IN_SOME_ITENS')
        }

        if (this.getCustomerName === '' || this.getCustomerName === 'Não informado') {
          return this.$t('PAY_BOX_SALE.CUSTOMER.CUSTOMER_NAME_IS_REQUIRED')
        }
      }

      return null
    },

    async onCleanSale() {
      await this.stCleanPayBox()
      console.debug('[onCleanSale] stCleanPayBox')
      await this.stCleanPayBoxInvoiceMetadata()
      console.debug('[onCleanSale] stCleanPayBoxInvoiceMetadata')
      await this.stClearPayBoxRewardData()
      console.debug('[onCleanSale] stClearPayBoxRewardData')
      this.saleFinished = false
      this.actualTab = 0
    },

    purchaseInfoShortcuts(e) {
      const setActualTab = val => {
        this.actualTab = val
      }

      const actionsF = {
        [this.keyCode.f5]: () => this.onCancel(),
        [this.keyCode.f6]: () => setActualTab(this.tabEnum.product),
        [this.keyCode.f7]: () => setActualTab(this.tabEnum.client),
        [this.keyCode.f10]: () => this.onFinish(),
      }

      if (actionsF[e.code]) {
        e.preventDefault()
        if (actionsF[e.code]) actionsF[e.code]()
      }
    },

    purchaseInfoRemoveEvents() {
      this.removeKeyEvent(this.purchaseInfoShortcuts)
      this.removeKeyEvent(this.$refs.productTab.productShortcut)
    },
    purchaseInforAddEvents() {
      this.addKeyEvent(this.purchaseInfoShortcuts)
      this.addKeyEvent(this.$refs.productTab.productShortcut)
    },
  },
}
</script>

<style lang="scss" scoped>
.content-tab {
  overflow-y: auto;
}

kbd {
  background-color: var(--dark);
}

.bold {
  font-weight: 600;
}
</style>
